import { createContext } from 'react';

const Context = createContext({
	sections: [],
	updateSections: () => {},
	setSections: () => {}
});

export default Context;
